import axios from 'axios';
import * as Config from '../../config';

const state = { };

const actions = {
    crash_report_store({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'carsh-report/store', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
};

const mutations = { };

export default {
    state,
    actions,
    mutations
};